import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { PageEndpointEnum } from "../../enums/endpoints";
import { LinkText, MobileHeaderRow } from "./style";
import { ReactComponent as Logo } from "../../assets/logo/logo_text_white.svg";
import { AuthContext } from "../../context/AuthContext";
import { hasPageAccess } from "../../constants/permissions";
import { isAffiliateTestEnvironment } from "../../utils/env";

export function MobileHeader() {
  const { userEmail } = useContext(AuthContext);
  const { pathname } = useLocation();

  return (
    <MobileHeaderRow>
      <Link to={PageEndpointEnum.DASHBOARD}>
        <Logo height={20} width={60} />
      </Link>
      {isAffiliateTestEnvironment() && hasPageAccess(userEmail, PageEndpointEnum.AFFILIATES) && (
        <Link to={PageEndpointEnum.AFFILIATES}><LinkText isActive={pathname === PageEndpointEnum.AFFILIATES}>Affiliates</LinkText></Link>
      )}
      {hasPageAccess(userEmail, PageEndpointEnum.GEOLOCATIONS) && (
        <Link to={PageEndpointEnum.GEOLOCATIONS}>
          <LinkText isActive={pathname === PageEndpointEnum.GEOLOCATIONS}>
            Geolocations
          </LinkText>
        </Link>
      )}
    </MobileHeaderRow>
  );
}
